<template>
  <div
    class="overlay"
    :class="[isShow ? showClass : hideClass]"
    id="popup-maintenance"
  >
    <div class="popup" style="width: 480px">
      <div class="popup-body">
        <div class="popup-status">
          <p class="popup-status-text newline">
            {{ message }}
          </p>
        </div>
        <div class="frm-btn-row">
          <div class="frm-item grow center">
            <button class="frm-btn strong large" @click="confirm">はい</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Common from "@/util/common.js";
import { SYSTEM_CLOSE_TYPE } from "@/util/data.js";

export default {
  name: "PreOcclusionDialog",
  props: {
    isShow: {
      type: Boolean,
      required: true,
    },
    time: {
      type: String,
      required: true,
    },
    closeType: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      showClass: "show",
      hideClass: "hide",
      message: "",
    };
  },
  created() {},
  watch: {
    time: function (newVal) {
      const type =
        this.closeType == 0
          ? SYSTEM_CLOSE_TYPE.SystemClosedTime
          : SYSTEM_CLOSE_TYPE.MaintenanceTime;
      this.message = Common.getMessage("MTCL2072", [newVal, type, type]);
    },
  },

  methods: {
    // **********************************************
    // * ダイアログを閉じます
    // **********************************************
    confirm() {
      this.$emit("confirm");
    },
  },
};
</script>